import { BACK_TYPE, Step, STEP_TYPE } from '@/types/step'

export enum CONSULTATION_TYPE {
  MEDICAL = 'text', // TODO medical or text?
  PRESCRIPTION = 'prescription',
  VOICE = 'voice',
  VIDEO = 'video',
  ASSESSMENT = 'assessment'
}

export enum CONSULTATION_STEPS {
  LANDING = 'landing',
  FORM = 'form',
  MATCHING = 'matching',
  MATCH = 'match',
  ANSWER = 'answer'
}

export enum IndicationFileStatus {
  CREATING = 'CREATING',
  CREATED = 'CREATED',
  ERROR = 'ERROR'
}

export type IndicationFiles =
  | {
      status: IndicationFileStatus.CREATING
    }
  | {
      status: IndicationFileStatus.CREATED
      url: string
    }
  | {
      status: IndicationFileStatus.ERROR
      message: string
    }

export type License = {
  licenseNumber: string
  countries: string[]
}

export type Professional = {
  name: string
  title: string
  specialties: string[]
  licenses: License[]
  profileUrl: string
  gender: string
  profileImg: string
}

export type Question = {
  createdAt?: number // timestamp
  question: string
  attachments: string[] // Urls to bucket

  // If answered ↓
  professional?: Professional
  answer?: string
}

export enum CONSULTATION_STATUS {
  NEW = 'new',
  OPEN = 'open',
  CLAIMED = 'claimed',
  RESOLVED = 'resolved',
  CANCELED = 'canceled',
  CLOSED = 'closed',
  CLOSED_WORATING = 'closedworating',
  WAITING_FOR_RATING = 'waitingforrating'
}

export type Consultation = {
  consultationId: string
  createdAt: number
  questions: Question[] // Up to 3
  status: CONSULTATION_STATUS
  userId: string
  professional?: Professional

  caseConsultationPdf?: IndicationFiles
}

export const CONSULTATION_LANDING_STEP: Step = {
  id: 'consultation-landing',
  name: 'consultation-landing',
  type: STEP_TYPE.CONSULTATION,
  components: {},
  componentsOrder: [],
  stepper: 1,
  backButton: BACK_TYPE.SHORT
}

export const STEP_STEPPER: Record<CONSULTATION_STEPS, number> = {
  [CONSULTATION_STEPS.LANDING]: 1,
  [CONSULTATION_STEPS.FORM]: 1,
  [CONSULTATION_STEPS.MATCHING]: 2,
  [CONSULTATION_STEPS.MATCH]: 2,
  [CONSULTATION_STEPS.ANSWER]: 3
}
